import React from "react";
import { InputRangeRow } from "./index";
// Used on Heli 2008B and Heli KV2019B machines

export default function ClockSetRow() {
   return (
      <InputRangeRow
         titleProp={"Clock Setting"}
         descriptionProp={"m"}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={0}
         maxProp={999999} //some default value
         propertyNameProp={"clockSet"}
         errorDialogueProp={"0-999,999"}
         floatProp={false}
      />
   );
}
